import React, {useEffect, useState} from 'react';
import LessonEditorUI from '../view/LessonEditorUI';
import {useParams} from 'react-router-dom';
import {inject, observer} from 'mobx-react';
import {createContext} from 'react';
import AddVideoSourceWizardStore from '../../../modules/Editor/AddVideoSourceWizard/store/AddVideoSourceWizardStore';
import {AddVideoSourceWizard} from '../../../modules/Editor/AddVideoSourceWizard';
import LessonEditorStore from '../store/LessonEditorStore';
import {LessonContentList} from '../../../data/models/LessonContent/LessonContentList';
import {
  ACKNOWLEDGMENT_NODE,
  BRANCH_BACKGROUND_FREEFORM,
  BRANCH_IMAGE_FREEFORM,
  BRANCH_SHAPE_FREEFORM,
  BRANCH_TEXT_FREEFORM,
  CHALLENGE_BRANCH_AI,
  CHALLENGE_BRANCH_HEADER,
  CHALLENGE_BRANCH_IMAGE_OPTION,
  CHALLENGE_BRANCH_QUESTION,
  CHALLENGE_BRANCH_TEXT_OPTION,
  CHOICE_HEADER_NODE_TYPE,
  CHOICE_IMAGE_OPTION,
  CHOICE_TEXT_OPTION,
  CHOICE_TEXT_QUESTION,
  IMAGE_NODE_TYPE,
  JUMP_TO_NODE,
  LessonContentBase,
  LessonContentChallengeBranchImageOption,
  LessonContentChallengeChoiceHeader,
  LessonContentChoiceHeader,
  LessonContentChoiceImageOption,
  LessonContentVideoBackgorund,
  MULTIPLE_CHOICE,
  OPENENDED_QUESTION_NODE_TYPE,
  OpenEndedQuestionContent,
  OVERLAY_VIDEO_TYPE,
  RECORD_VIDEO_TYPE,
  VIDEO_NODE_TYPE,
} from '../../../data/models/LessonContent/LessonContentBase';
import {AddChoiceQuestionWizard} from '../../../modules/Editor/AddChoiceQuestionWizard';
import AddChoiceQuestionStore from '../../../modules/Editor/AddChoiceQuestionWizard/store/AddChoiceQuestionStore';
import {AddChoiceTextOptionWizard} from '../../../modules/Editor/AddChoiceTextOptionWizard';
import AddChoiceTextOptionWizardStore from '../../../modules/Editor/AddChoiceTextOptionWizard/store/AddChoiceTextOptionWizardStore';
import MyLibraryModalStore from '../../../modules/MyLibraryModal/store/MyLibraryModalStore';
import {
  MEDIA_FILES_ALL_VIDEO,
  MEDIA_FILES_IMAGE,
} from '../../../data/models/LibraryFile/MediaFile';
import {MyLibraryModal} from '../../../modules/MyLibraryModal';
import AddMChoiceWizardStore from '../../../modules/Editor/AddMChoiceWizard/store/AddMChoiceWizardStore';
import {AddMChoiceWizard} from '../../../modules/Editor/AddMChoiceWizard';
import {AddChallengeBranchQuestionWizard} from '../../../modules/Editor/AddChallengeBranchQuestionWizard';
import AddChallengeBranchQuestionStore from '../../../modules/Editor/AddChallengeBranchQuestionWizard/store/AddChallengeBranchQuestionStore';
import {AddChallengeBranchTextOptionWizard} from '../../../modules/Editor/AddChallengeBranchTextOptionWizard';
import AddChallengeBranchTextOptionStore from '../../../modules/Editor/AddChallengeBranchTextOptionWizard/store/AddChallengeBranchTextOptionStore';
import AddChallengeBranchAIStore from '../../../modules/Editor/AddChallengeBranchAIWizard/store/AddChallengeBranchAIStore';
import {AddChallengeBranchAIWizard} from '../../../modules/Editor/AddChallengeBranchAIWizard';
import AddVideoOverlayStore from '../../../modules/Editor/AddVideoOverlayWizard/store/AddVideoOverlayStore';
import {
  AddVideoOverlay,
  EditVideoOverlay,
} from '../../../modules/Editor/AddVideoOverlayWizard';
import AddFreeformChoiceStore from '../../../modules/Editor/AddFreeformChoiceOption/store/AddFreeformChoiceStore';
import {AddFreeformChoice} from '../../../modules/Editor/AddFreeformChoiceOption';
import AddJumpToWizardStore from '../../../modules/Editor/AddJumpToWizard/store/AddJumpToWizardStore';
import AddJumpToWizardContainer from '../../../modules/Editor/AddJumpToWizard/container/AddJumpToWizardContainer';
import AddAcknowledgmentWizardStore from '../../../modules/Editor/AddAcknowledgmentWizard/store/AddAcknowledgmentWizardStore';
import {AddAcknowledgmentWizard} from '../../../modules/Editor/AddAcknowledgmentWizard';
import AddImageNodeWizardStore from '../../../modules/Editor/AddImageNodeWizard/store/AddImageNodeWizardStore';
import {AddImageNodeWizard} from '../../../modules/Editor/AddImageNodeWizard';
import NavigationStore from '../../../navigation/store/NavigationStore';
import {
  organizationHasFeature,
  SCORM_RUNTIME_SUB_FEATURE,
} from '../../../data/models/Subscription/SubscriptionPermission';
import {lessonEditorText} from '../lessonEditorText';
import RecordVideoModal from '../../../modules/RecordVideo/RecordVideoModal';
import recordVideoStyles from '../../../modules/RecordVideo/RecordVideoModal.module.css';
import LibraryRepository from '../../../data/repositories/LibraryRepository';
import {toast} from 'react-toastify';
import {toastConfig} from '../../../uiToolkit/Toast/toastConfig';
import ModalContainer from '../../../uiToolkit/ModalContainer';
import LoadingSpinner from '../../../uiToolkit/LoadingSpinner/LoadingSpinner';

export const EditorContext = createContext({
  selectedNode: undefined,
  selectedNodeType: '',
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  setSelectedNode: (node: any, type: string) => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  addNewNode: (parentId: string, type: number) => {},
  isGradable: false,
  isPublished: false,
  isFinalAssessment: false,
  lessonContent: undefined,
  permissions: {},
} as any);

interface InjectedStoreProps {
  addVideoSourceWizardStore?: AddVideoSourceWizardStore;
  addChoiceQuestionStore?: AddChoiceQuestionStore;
  lessonEditorStore?: LessonEditorStore;
  addChoiceTextOptionWizardStore?: AddChoiceTextOptionWizardStore;
  myLibraryModalStore?: MyLibraryModalStore;
  addMChoiceWizardStore?: AddMChoiceWizardStore;
  addChallengeBranchQuestionStore?: AddChallengeBranchQuestionStore;
  addChallengeBranchTextOptionStore?: AddChallengeBranchTextOptionStore;
  addChallengeBranchAIStore?: AddChallengeBranchAIStore;
  addVideoOverlayStore?: AddVideoOverlayStore;
  addFreeformChoiceStore?: AddFreeformChoiceStore;
  addJumpToWizardStore?: AddJumpToWizardStore;
  addAcknowledgmentWizardStore?: AddAcknowledgmentWizardStore;
  addImageNodeWizardStore?: AddImageNodeWizardStore;
  navigationStore?: NavigationStore;
}

interface Props {
  breadcrumbs: {title: string; link?: string}[];
  isGradable: boolean;
  onBack: () => void;
  onPreview: () => void;
  onPublish?: () => void;
  exportAsScorm?: () => void;
  currentLessonId: string;
  lessonTitle: string;
  hideSidebar?: boolean;
  isFinalAssessment?: boolean;
}

const LessonEditorContainer = inject(
  'addVideoSourceWizardStore',
  'addChoiceQuestionStore',
  'addChoiceTextOptionWizardStore',
  'myLibraryModalStore',
  'lessonEditorStore',
  'addMChoiceWizardStore',
  'addChallengeBranchQuestionStore',
  'addChallengeBranchTextOptionStore',
  'addChallengeBranchAIStore',
  'addVideoOverlayStore',
  'addFreeformChoiceStore',
  'addJumpToWizardStore',
  'addAcknowledgmentWizardStore',
  'addImageNodeWizardStore',
  'navigationStore',
)(
  observer(
    ({
      addVideoSourceWizardStore,
      lessonEditorStore,
      addChoiceQuestionStore,
      addChoiceTextOptionWizardStore,
      myLibraryModalStore,
      addMChoiceWizardStore,
      addChallengeBranchQuestionStore,
      addChallengeBranchTextOptionStore,
      addChallengeBranchAIStore,
      addVideoOverlayStore,
      addFreeformChoiceStore,
      addJumpToWizardStore,
      addAcknowledgmentWizardStore,
      addImageNodeWizardStore,
      navigationStore,
      breadcrumbs,
      isGradable,
      onBack,
      onPreview,
      onPublish,
      exportAsScorm,
      currentLessonId,
      lessonTitle,
      hideSidebar,
      isFinalAssessment,
    }: Props & InjectedStoreProps) => {
      const [selectedNode, setSelectedNode] = useState<LessonContentBase>();
      const [selectedNodeType, setSelectedNodeType] = useState(-1);
      const [publishedId, setPublisehdId] = useState<string>();
      const [lessonContent, setLessonContent] = useState<LessonContentList>();
      const [showRecordVideo, setShowRecordVideo] = useState(false);
      const [recordedBlobUrl, setRecordedBlobUrl] = useState<string | null>(
        null,
      );
      const [recordVideoParentId, setRecordVideoParentId] = useState<
        string | null
      >(null);
      const [recordVideoNodeToReplace, setRecordVideoNodeToReplace] = useState<
        LessonContentBase | undefined
      >();
      const [recordVideoChildId, setRecordVideoChildId] = useState<
        string | undefined
      >();
      const [isUploadingRecording, setIsUploadingRecording] = useState(false);

      const {organizationId, lessonId} = useParams();

      useEffect(() => {
        if (currentLessonId !== lessonId) {
          window.location.reload();
        }
      }, [lessonId]);

      useEffect(() => {
        fetchContent();
        if (organizationId && lessonId) {
          lessonEditorStore!
            .getLessonIsPublished(organizationId, lessonId)
            .then(res => setPublisehdId(res?.publishedId));
        }
        navigationStore!.tryGetMyOrganization();
      }, [lessonId]);

      const fetchContent = () => {
        setLessonContent(undefined);
        if (organizationId && lessonId) {
          onClearSelectedNode();
          lessonEditorStore
            ?.getLessonContent(organizationId, lessonId)
            .then(setLessonContent);
        }
      };

      const onSelectNode = (node: any, type: any) => {
        setSelectedNode(node);
        setSelectedNodeType(type);
      };

      const getNodeById = (id: string) => {
        if (lessonContent && lessonContent.contentList) {
          return lessonContent.contentList.items[id];
        }
      };

      const onClearSelectedNode = () => {
        setSelectedNode(undefined);
        setSelectedNodeType(-1);
      };

      const onChangesMade = () => {
        fetchContent();
      };

      const getChildForParent = (parentId: string) => {
        let childId = '';
        if (lessonContent) {
          Object.keys(lessonContent.contentList.items).forEach(key => {
            if (
              lessonContent.contentList.items[key]?.parentsIds?.includes(
                parentId,
              )
            ) {
              childId = key;
            }
          });
        }
        return childId;
      };

      const addNewNodeDefaults = {
        openEndedQuestion: {
          ivNodeType: OPENENDED_QUESTION_NODE_TYPE,
          gradeWeight: 1,
          textAreaAnswerEnabled: true,
          textAreaAnswerPrompt:
            lessonEditorText.openEndedQuestionDefaultTestAreaPrompt,
          textAreaAnswerMaxCharacterCount: 1000,
          attachmentAnswerEnabled: false,
          attachmentAnswerPrompt:
            lessonEditorText.openEndedQuestionDefaultAttachmentPrompt,
          attachmentAnswerFileTypes: ['pdf', 'docx', 'txt'],
          attachmentAnswerMaxFileKb: 1024,
        } as OpenEndedQuestionContent,
      };

      const addNewNode = (
        parentId: string,
        type: number,
        nodeToReplace?: LessonContentBase,
      ) => {
        const childId = getChildForParent(parentId);
        if (organizationId && lessonId) {
          if (type === VIDEO_NODE_TYPE) {
            myLibraryModalStore!.showLibrary(MEDIA_FILES_ALL_VIDEO, files => {
              addVideoSourceWizardStore?.startWizard(
                fetchContent,
                files[0],
                undefined,
                parentId,
                nodeToReplace,
                childId,
              );
            });
          }
          if (type === RECORD_VIDEO_TYPE) {
            setRecordVideoParentId(parentId);
            setRecordVideoNodeToReplace(nodeToReplace);
            setRecordVideoChildId(childId);
            setShowRecordVideo(true);
          }
          if (type === CHOICE_HEADER_NODE_TYPE) {
            lessonEditorStore
              ?.addLessonNode(organizationId, lessonId, parentId, {
                ivNodeType: type,
                title: '',
              } as unknown as LessonContentChoiceHeader)
              .then(fetchContent);
          }
          if (type === CHOICE_TEXT_QUESTION) {
            addChoiceQuestionStore?.startWizard(parentId, fetchContent);
          }
          if (type === CHOICE_TEXT_OPTION) {
            addChoiceTextOptionWizardStore!.startWizard(parentId, fetchContent);
          }
          if (type === CHOICE_IMAGE_OPTION) {
            myLibraryModalStore!.showLibrary(MEDIA_FILES_IMAGE, files => {
              if (files.length) {
                lessonEditorStore!
                  .addLessonNode(organizationId, lessonId, parentId, {
                    ivNodeType: CHOICE_IMAGE_OPTION,
                    contentId: files[0].storageFileName,
                  } as LessonContentChoiceImageOption)
                  .then(fetchContent);
              }
            });
          }
          if (type === MULTIPLE_CHOICE) {
            const parent = getNodeById(parentId);
            if (parent) {
              addMChoiceWizardStore?.startWizard(
                parent.data,
                lessonId,
                fetchContent,
                nodeToReplace,
                childId,
              );
            }
          }
          if (type === CHALLENGE_BRANCH_HEADER) {
            lessonEditorStore
              ?.addLessonNode(organizationId, lessonId, parentId, {
                ivNodeType: type,
              } as unknown as LessonContentChallengeChoiceHeader)
              .then(fetchContent);
          }
          if (type === CHALLENGE_BRANCH_QUESTION) {
            addChallengeBranchQuestionStore!.openWizard(parentId, fetchContent);
          }
          if (type === CHALLENGE_BRANCH_IMAGE_OPTION) {
            myLibraryModalStore!.showLibrary(MEDIA_FILES_IMAGE, files => {
              if (files.length) {
                lessonEditorStore!
                  .addLessonNode(organizationId, lessonId, parentId, {
                    ivNodeType: CHALLENGE_BRANCH_IMAGE_OPTION,
                    contentId: files[0].storageFileName,
                    isCorrect: false,
                  } as LessonContentChallengeBranchImageOption)
                  .then(fetchContent);
              }
            });
          }
          if (type === CHALLENGE_BRANCH_TEXT_OPTION) {
            addChallengeBranchTextOptionStore!.openWizard(
              parentId,
              fetchContent,
            );
          }
          if (type === CHALLENGE_BRANCH_AI) {
            addChallengeBranchAIStore!.startWizard(parentId, fetchContent);
          }
          if (type === OVERLAY_VIDEO_TYPE && lessonContent) {
            myLibraryModalStore!.showLibrary(MEDIA_FILES_ALL_VIDEO, files => {
              addVideoOverlayStore!.openWizard(
                parentId,
                files[0],
                null,
                fetchContent,
                lessonContent,
                isGradable,
                undefined,
                nodeToReplace,
                childId,
              );
            });
          }
          if (type === BRANCH_IMAGE_FREEFORM && lessonContent) {
            myLibraryModalStore!.showLibrary(MEDIA_FILES_IMAGE, files => {
              if (files.length) {
                addFreeformChoiceStore!.showWizard(
                  parentId,
                  type,
                  fetchContent,
                  lessonContent,
                  {
                    id: files[0].storageFileName,
                    url: files[0].fileUrl || '',
                  },
                  nodeToReplace,
                );
              }
            });
          }
          if (
            (type === BRANCH_SHAPE_FREEFORM || type === BRANCH_TEXT_FREEFORM) &&
            lessonContent
          ) {
            addFreeformChoiceStore!.showWizard(
              parentId,
              type,
              fetchContent,
              lessonContent,
              undefined,
              nodeToReplace,
            );
          }
          if (type === JUMP_TO_NODE) {
            addJumpToWizardStore!.startWizard(
              parentId,
              fetchContent,
              nodeToReplace,
            );
          }
          if (type === BRANCH_BACKGROUND_FREEFORM) {
            const parent = getNodeById(parentId);
            if (nodeToReplace) {
              lessonEditorStore!
                .editContentNode(organizationId, lessonId, {
                  ivNodeType: BRANCH_BACKGROUND_FREEFORM,
                  isCorrect:
                    parent?.data.ivNodeType === CHALLENGE_BRANCH_QUESTION
                      ? false
                      : undefined,
                  internalId: nodeToReplace.internalId,
                } as LessonContentVideoBackgorund)
                .then(fetchContent);
            } else {
              lessonEditorStore!
                .addLessonNode(organizationId, lessonId, parentId, {
                  ivNodeType: BRANCH_BACKGROUND_FREEFORM,
                  isCorrect:
                    parent?.data.ivNodeType === CHALLENGE_BRANCH_QUESTION
                      ? false
                      : undefined,
                } as LessonContentVideoBackgorund)
                .then(fetchContent);
            }
          }
          if (type === ACKNOWLEDGMENT_NODE) {
            addAcknowledgmentWizardStore!.openWizard(
              parentId,
              fetchContent,
              nodeToReplace,
              childId,
            );
          }
          if (type === IMAGE_NODE_TYPE) {
            myLibraryModalStore!.showLibrary(MEDIA_FILES_IMAGE, files => {
              if (files.length) {
                addImageNodeWizardStore!.openWizard(
                  parentId,
                  files[0],
                  fetchContent,
                  nodeToReplace,
                  childId,
                );
              }
            });
          }
          if (type === OPENENDED_QUESTION_NODE_TYPE) {
            if (nodeToReplace) {
              lessonEditorStore!
                .editContentNode(organizationId, lessonId, {
                  ...addNewNodeDefaults.openEndedQuestion,
                  internalId: nodeToReplace.internalId,
                })
                .then(fetchContent);
            } else {
              lessonEditorStore
                ?.addLessonNode(
                  organizationId,
                  lessonId,
                  parentId,
                  addNewNodeDefaults.openEndedQuestion,
                  childId,
                )
                .then(fetchContent);
            }
          }
        }
      };

      const onRecordVideoSave = async (file: File) => {
        if (!organizationId) return;
        setShowRecordVideo(false);
        setIsUploadingRecording(true);
        const blobUrl = URL.createObjectURL(file);
        setRecordedBlobUrl(blobUrl);

        try {
          const duration = await new Promise<number>(resolve => {
            const video = document.createElement('video');
            video.preload = 'metadata';
            video.onloadedmetadata = () => {
              resolve(video.duration || 0);
            };
            video.onerror = () => {
              resolve(0);
            };
            video.src = blobUrl;
          });

          const libraryRepo = new LibraryRepository();
          const result: any = await libraryRepo.uploadVideo(
            organizationId,
            file,
            duration,
            0,
          );
          if (result.success) {
            const mediaFile = {
              id: result.data?.id || '',
              fileName: file.name,
              fileType: file.type,
              storageFileName: result.data?.storageFileName || '',
              fileUrl: blobUrl,
              dateCreated: new Date(),
              fileSize: Math.ceil(file.size / 1024 / 1024),
              isUsed: false,
            };
            addVideoSourceWizardStore?.startRecordVideoWizard(
              fetchContent,
              mediaFile,
              recordVideoParentId || undefined,
              recordVideoNodeToReplace,
              recordVideoChildId,
            );
          } else {
            toast.error(lessonEditorText.uploadRecordingFailed, toastConfig);
          }
        } catch {
          toast.error(lessonEditorText.uploadRecordingFailed, toastConfig);
        } finally {
          setIsUploadingRecording(false);
          setRecordVideoParentId(null);
          setRecordVideoNodeToReplace(undefined);
          setRecordVideoChildId(undefined);
          if (recordedBlobUrl) {
            URL.revokeObjectURL(recordedBlobUrl);
            setRecordedBlobUrl(null);
          }
        }
      };

      const onReRecord = () => {
        if (selectedNode && lessonContent) {
          const item = lessonContent.contentList.items[selectedNode.internalId];
          if (item?.parentsIds?.length) {
            setRecordVideoParentId(item.parentsIds[0]);
          }
          setRecordVideoNodeToReplace(selectedNode);
          setShowRecordVideo(true);
        }
      };

      const onRecordVideoCancel = () => {
        setShowRecordVideo(false);
        setRecordVideoParentId(null);
        setRecordVideoNodeToReplace(undefined);
        setRecordVideoChildId(undefined);
        if (recordedBlobUrl) {
          URL.revokeObjectURL(recordedBlobUrl);
          setRecordedBlobUrl(null);
        }
      };

      return (
        <EditorContext.Provider
          value={{
            selectedNode,
            selectedNodeType,
            setSelectedNode: onSelectNode,
            addNewNode: addNewNode,
            isGradable: isGradable,
            isPublished: publishedId,
            isFinalAssessment: isFinalAssessment,
            lessonContent: lessonContent,
            permissions: navigationStore!.subscriptionPermissions,
          }}>
          <LessonEditorUI
            onBack={onBack}
            selectedItem={selectedNode}
            lessonTitle={lessonTitle}
            onExportScorm={exportAsScorm}
            selectedItemType={selectedNodeType}
            lessonContent={lessonContent}
            onClearSelectedNode={onClearSelectedNode}
            onChangesMade={onChangesMade}
            onPreview={onPreview}
            onPublish={onPublish}
            isGradable={isGradable}
            hideSidebar={hideSidebar}
            lessonIsPublisehd={
              publishedId !== undefined && publishedId !== null
            }
            breadcrumbs={breadcrumbs}
            hideScorm={
              !organizationHasFeature(
                navigationStore!.subscriptionPermissions,
                SCORM_RUNTIME_SUB_FEATURE,
              )
            }
            onReRecord={onReRecord}
          />
          <AddVideoSourceWizard />
          <AddChoiceQuestionWizard />
          <AddChoiceTextOptionWizard />
          <MyLibraryModal />
          <AddMChoiceWizard lessonContent={lessonContent} />
          <AddChallengeBranchQuestionWizard />
          <AddChallengeBranchTextOptionWizard />
          <AddChallengeBranchAIWizard />
          <AddVideoOverlay />
          {lessonContent && <AddFreeformChoice lessonContent={lessonContent} />}
          <AddJumpToWizardContainer lessonContent={lessonContent} />
          <EditVideoOverlay />
          <AddAcknowledgmentWizard />
          <AddImageNodeWizard />
          {showRecordVideo && (
            <RecordVideoModal
              onSave={onRecordVideoSave}
              onCancel={onRecordVideoCancel}
            />
          )}
          {isUploadingRecording && (
            <ModalContainer onClose={() => undefined} hideCloseButton>
              <div className={recordVideoStyles.uploadingContainer}>
                <LoadingSpinner size={32} />
                <p className={recordVideoStyles.uploadingText}>
                  {lessonEditorText.uploadingRecording}
                </p>
              </div>
            </ModalContainer>
          )}
        </EditorContext.Provider>
      );
    },
  ),
);

export default LessonEditorContainer;
